import { html } from "lit";
var icon_display_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 24">
    <path
      d="M25.928.857H2.5a2 2 0 00-2 2v14.857a2 2 0 002 2h23.428a2 2 0 002-2V2.857a2 2 0 00-2-2zM2.5 2.571h23.428c.158 0 .286.128.286.286v14.857a.286.286 0 01-.286.286H2.5a.286.286 0 01-.286-.286V2.857c0-.158.128-.286.286-.286z" />
    <path d="M15.071 18.857l-.001 3.429h4.287V24H9.071v-1.714h4.285l.001-3.429z" />
    <path
      d="M25.928.857H2.5a2 2 0 00-2 2v14.857a2 2 0 002 2h23.428a2 2 0 002-2V2.857a2 2 0 00-2-2zM2.5 2.571h23.428c.158 0 .286.128.286.286v14.857a.286.286 0 01-.286.286H2.5a.286.286 0 01-.286-.286V2.857c0-.158.128-.286.286-.286z" />
    <path d="M15.071 18.857l-.001 3.429h4.287V24H9.071v-1.714h4.285l.001-3.429z" />
  </svg>
`;
export {
  icon_display_default as default
};
//# sourceMappingURL=icon-display.js.map
